import { useMutation } from "@tanstack/react-query";
import { createCheckout } from "../api/createCheckout";

/**
 * Open a Polar checkout session. The caller redirects the browser to the
 * returned URL (`window.location.href = data.url`); we leave the SPA, so there
 * is no success state to render here.
 */
export function useCheckout() {
  return useMutation({ mutationFn: createCheckout });
}
